<script>
	import { uiText } from "../lib/uiText.js";
	import { initializeApp } from "firebase/app";
	import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
	import {
		getAuth,
		onAuthStateChanged,
		GoogleAuthProvider,
		signInWithPopup,
	} from "firebase/auth";
	import { getFirestore, getDoc, doc } from "firebase/firestore";
	// import { getStorage } from 'firebase/storage';
	import { firebaseConfig } from "../lib/firebaseConfig";
	import Loader from "../play/Loader.svelte";
	import GameFooter from "../play/GameFooter.svelte";
	import LatestOrders from "./LatestOrders.svelte";
	import GameCreator from "./GameCreator.svelte";
	import AutoEmails from "./AutoEmails.svelte";
	import GameDisplay from "./GameDisplay.svelte";
	import GacGenerator from "./GACGenerator.svelte";
	import GacSearchUpdate from "./GACSearchUpdate.svelte";
	import QrDisplay from "./QRDisplay.svelte";
	import TempAdmin from "./TempAdmin.svelte";
	import GameDisplayNew from "./GameDisplayNew.svelte";
	import DataComp from "./DataComp.svelte";
	import GameDisplayTeam from "./GameDisplayTeam.svelte";

	const firebaseApp = initializeApp(firebaseConfig);
	const auth = getAuth(app);
	// const analytics = getAnalytics();
	const db = getFirestore();
	// const storage = getStorage(firebaseApp);
	const appCheck = initializeAppCheck(app, {
		provider: new ReCaptchaV3Provider(
			"6LccY4UfAAAAAI3JgHICpZsbbxZFqtzMCFSjIyOP",
		),
		// Optional argument. If true, the SDK automatically refreshes App Check
		// tokens as needed.
		isTokenAutoRefreshEnabled: true,
	});
	const google = new GoogleAuthProvider();

	const locals = {
		en: "en",
		bg: "bg",
	};
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	let local = urlParams.get("l") || urlParams.get("lang") || navigator.language; //defaults to user's language if no language is set via link parameters
	export let hasPrefLangSet = false;
	export let lang = checkPreferedLang();

	$: lang, changeHTMLlang();

	function changeHTMLlang() {
		document.documentElement.lang = lang;
	}

	export function checkPreferedLang() {
		if (localStorage.getItem("hasPreferedLang") === null) {
			hasPrefLangSet = false;
			return locals[local] || "bg"; //defaults to ~english~ BULGARIAN if the user's language or the link param. language is not in the list
		} else {
			if (localStorage.getItem("preferedLanguage") !== null) {
				hasPrefLangSet = true;
				return localStorage.getItem("preferedLanguage");
			}
		}
	}

	function setLang(l) {
		localStorage.setItem("hasPreferedLang", true);
		localStorage.setItem("preferedLanguage", l);
		hasPrefLangSet = true;
	}

	let isAdmin = undefined;
	let loader = true;
	let screen = false;
	let panel = "menu";
	let showLangSelector;

	let randomVar = "";

	// let standalone =
	//     window.navigator.standalone !== undefined ||
	//     window.clientInformation.standalone !== undefined
	//         ? window.navigator.standalone || window.clientInformation.standalone
	//         : false;

	let ui = uiText(lang);
	$: lang, (ui = uiText(lang)), setLang(lang);

	// NEW CODE BELOW

	onAuthStateChanged(auth, (authUser) => {
		if (authUser) {
			// list of available properties - https://firebase.google.com/docs/reference/js/firebase.User
			user.name = authUser.displayName;
			user.photo = authUser.photoURL;
			user.uid = authUser.uid;
			checkIsAdmin(authUser.uid);
		} else {
			loader = false;
			isAdmin = false;
		}
	});
	async function checkIsAdmin(authUID) {
		const actSesSnap = await getDoc(doc(db, "users", authUID));

		if (actSesSnap.exists()) {
			let snapData = actSesSnap.data();
			// console.log(snapData);
			if (snapData.isAdmin) {
				isAdmin = true;
				// console.log("is admin");
				loader = false;
			} else {
				isAdmin = false;
				// console.log("is NOT admin");

				loader = false;
			}
		} else {
			console.log("No such user!");
		}
	}

	let user = {
		name: "",
		uid: "",
		photo:
			"https://firebasestorage.googleapis.com/v0/b/vutreshen-glas.appspot.com/o/vg-template%2Fvg-navigate.png?alt=media&token=f7a09181-690b-43e0-b2f9-a4ec2e6112ba",
		email: "",
	};

	function handleLoader(e) {
		loader = e.detail;
	}

	document.body.classList.add("obelisk-body");

	function authWithGoogle() {
		loader = true;
		signInWithPopup(auth, google)
			.then((result) => {
				// loader = false;
			})
			.catch((error) => {
				console.warn(error);
				loader = false;
			});
	}

	function handleScreen(e) {
		screen = e.detail;
	}
</script>

<!-- SVELTE HEAD -->
<svelte:head>
	<meta name="mobile-web-app-title" content="VG Panel" />
	<title>Panel | VutreshenGlas.com</title>
</svelte:head>

<!-- ADMIN -->
<!-- Game Display (QR for orders + teams currently "in") -->
<!-- Latest Orders preview -->
<!-- Free Game Access Code (GAC) Generator -->
<!-- GAC Search and Update -->
<!-- Display (for competitions, participating teams, both moving and finished) -->
<!-- Send Email with GAC -->

{#if loader || isAdmin === undefined}
	<Loader on:loader={handleLoader} {loader}>
		<p class="text-center">Loading Panel...</p>
		<p class="text-center">
			<small>This may take a while, please be patient.</small>
		</p>
	</Loader>
{/if}

{#if screen !== "showcase"}
	<header
		class="box-border flex justify-between h-20 text-base bg-blue-100 obelisk"
	>
		<img
			class="hidden h-full max-h-full p-4 xs:block"
			src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
			alt={ui.game.footer.vendor}
			on:click={() => (panel = "menu")}
		/>
		<img
			class="block h-full max-h-full p-4 xs:hidden"
			src="/img/svg/logo-icon.svg"
			alt={ui.game.footer.vendor}
			on:click={() => (panel = "menu")}
		/>

		<button
			class="ghost icon"
			on:click={() => (showLangSelector = !showLangSelector)}
			title={ui.game.header.lang_title}
		>
			{#if showLangSelector}
				<i
					class="fa-solid fa-times fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{:else}
				<i
					class="fa-solid fa-language fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{/if}
		</button>
		{#if showLangSelector}
			<div
				class="fixed right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90"
			>
				<button on:click={() => ((lang = "bg"), (showLangSelector = false))}
					>Български (Bulgarian)</button
				>
				<button on:click={() => ((lang = "en"), (showLangSelector = false))}
					>English (Английски)</button
				>
			</div>
		{/if}
	</header>
{/if}
<main class="grid gap-2 place-content-center obelisk">
	<!-- place-content-center -->
	<!-- {randomVar} -->

	{#if isAdmin}
		{#if panel == "menu"}
			<p class="uppercase">{user.name}</p>
			<h1>VutreshenGlas.com Public Panel</h1>
			<br />
			<div class="grid md:grid-cols-2">
				<!-- <button class="outline" on:click={() => (panel = "latest_orders")}>
					<i
						class="fa-solid fa-hand-holding-dollar"
						data-position="left"
					/>Latest orders ✅
				</button> -->
				<!-- <button class="outline" on:click={() => (panel = "free_gac")}>
					<i class="fa-solid fa-diagram-project" data-position="left" />Free GAC
					Generator ✅
				</button> -->
				<!-- <button class="outline" on:click={() => (panel = "gac_search")}>
					<i class="fa-brands fa-searchengin" data-position="left" />GAC Search
					& Update 🛑
				</button> -->
				<button class="outline" on:click={() => (panel = "game_display")}>
					<i class="fa-solid fa-display" data-position="left" />Game Display 💡
				</button>
				<!-- <button class="outline" on:click={() => (panel = "emails")}>
					<i class="fa-solid fa-square-up-right" data-position="left" />
					Game Display NEW ✅ 🆕
					
				</button> -->
				<button class="outline" on:click={() => (panel = "qr_display")}>
					<i class="fa-solid fa-qrcode" data-position="left" />QR Display ✅
				</button>
				<!-- <button class="outline" on:click={() => (panel = "game_creator")}>
					<i class="fa-solid fa-folder-plus" data-position="left" />Game Creator
					✅
				</button> -->
				<!-- <button class="outline" on:click={() => (panel = "users")}>
					<i class="fa-solid fa-screwdriver-wrench" data-position="left" />Users
					🛑
				</button> -->
				<!-- <button class="outline" on:click={() => (panel = "game_comp")}>
					<i class="fa-solid fa-screwdriver-wrench" data-position="left" />🛑
					GAME COMPILATION - EXPERIMENTAL - DON'T USE 🛑
				</button> -->
			</div>

			<button
				class="outline place-self-center"
				on:click={() => localStorage.clear()}
			>
				<i class="fa-solid fa-broom" data-position="left" />Clear local storage
			</button>
			<button
				class="outline place-self-center"
				on:click={() => sessionStorage.clear()}
			>
				<i class="fa-solid fa-broom" data-position="left" />Clear session
				storage
			</button>

			<button
				class="outline place-self-center"
				on:click={() => {
					if (window.confirm(ui.global.log_out_confirm)) {
						auth.signOut();
					}
				}}
			>
				<i class="fas fa-door-open" data-position="left" />{ui.global.log_out}
			</button>
		{:else}
			<!-- <button class="outline" on:click={() => (panel = 'menu')}>
                <i class="fa-solid fa-arrow-left" data-position="left" />{ui.login
                    .anon_back}</button
            > -->
			{#if panel == "latest_orders"}
				<LatestOrders {db} {lang} {loader} />
			{:else if panel == "free_gac"}
				<GacGenerator {db} {lang} {loader} {user} />
			{:else if panel == "gac_search"}
				<GacSearchUpdate {db} {lang} {loader} />
			{:else if panel == "game_display"}
				<!-- <GameDisplay {db} {lang} {loader} on:screen={handleScreen} /> -->
				<GameDisplayTeam {db} {lang} {loader} on:screen={handleScreen} />
			{:else if panel == "emails"}
				<GameDisplayTeam {db} {lang} {loader} on:screen={handleScreen} />
				<!-- <AutoEmails {db} {lang} {loader} /> -->
			{:else if panel == "qr_display"}
				<QrDisplay {db} {lang} {loader} on:screen={handleScreen} />
			{:else if panel == "game_creator"}
				<GameCreator {db} {lang} {loader} />
			{:else if panel == "users"}
				USERS
			{:else if panel == "game_comp"}
				<DataComp {db} {lang} {loader} on:screen={handleScreen} />
			{/if}
		{/if}
	{:else if user.name == ""}
		<h1>Hey, this area is protected</h1>
		<h3>If you're an admin, please sign in the system to access this page.</h3>
		<br />
		<p>
			<a href="debug-vgweb-game">Click here to go back to the home page.</a>
		</p>

		<button on:click={() => authWithGoogle()}
			><i class="fa-brands fa-google" data-position="left" />{ui.login
				.withGoogle}</button
		>
	{:else}
		<h1>Hey, this area is protected</h1>
		<h3>
			Your profile seems to be lacking proper credentials needed for the current
			page.
		</h3>
		<br />
		<p>
			<a href="debug-vgweb-game">Click here to go back to the home page.</a>
		</p>
		<p>
			If you think this is a mistake and you should be able to see this page,
			please contact us.
		</p>
		<button on:click={() => auth.signOut()}>Log out and switch profile</button>
	{/if}

	<!-- {:else if state == 'admin'} -->

	<!-- {:else} -->
	<!-- EDGE CASE -->
	<!-- {/if} -->
</main>
{#if screen !== "showcase"}
	<GameFooter {lang} />
{/if}

<!-- <button on:click={() => (loader = true)}>loader</button> -->

<!-- {#if globalState === 'login'}
   
{:else if globalState === 'game'}
    <Game
        {auth}
        {db}
        {user}
        {loader}
        {lang}
        on:loader={handleLoader}
        on:setLang={handleSetLang}
        on:state={handleState}
    />
{:else if globalState === 'conclusion'}
    <Conclusion
        {auth}
        {db}
        {user}
        {loader}
        {lang}
        on:loader={handleLoader}
        on:setLang={handleSetLang}
        on:state={handleState}
    /> -->

<!-- {:else}
    Something else - you should not see this...
{/if} -->
<style>
	* {
		color: white;
	}
	:global(.obelisk-body) {
		grid-template-rows: min-content auto min-content;
		word-break: break-word;
	}
	:global(.obelisk-body main) {
		padding-inline: 1rem;
		padding-top: 2rem;
	}
</style>
